var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKcLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 953,
    height: 166,
    viewBox: "0 0 953 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.516 44.0225H322.68V80.3506L356.444 44.0225H378.454L344.69 79.2822L379.95 127.15H357.939L332.296 91.8902L322.68 101.934V127.364H304.516V44.0225Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.723 94.2408L378.883 44.0225H400.252L420.126 77.3589L440.213 44.0225H460.942L429.101 93.8134V126.936H410.937V94.2408H410.723Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M472.266 44.0225H490.43V110.482H531.887V127.15H472.266V44.0225Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M545.777 44.0225H608.39V60.2633H563.941V77.1452H603.048V93.386H563.941V110.909H609.031V127.15H545.777V44.0225Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M657.113 85.6928V85.4791C657.113 61.9726 674.85 42.5264 700.493 42.5264C716.093 42.5264 725.496 47.655 733.189 55.3481L721.649 68.8109C715.238 63.0411 708.828 59.4083 700.493 59.4083C686.39 59.4083 676.346 70.9478 676.346 85.2654V85.4791C676.346 99.7967 686.176 111.55 700.493 111.55C709.896 111.55 715.879 107.703 722.29 101.72L733.83 113.473C725.282 122.662 715.879 128.218 699.852 128.218C675.277 128.432 657.113 109.413 657.113 85.6928Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M748.359 44.0213H766.523V76.7166H800.287V43.8076H818.451V126.935H800.287V93.5985H766.523V126.935H748.359V44.0213Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M839.396 44.0225H857.561V127.15H839.396V44.0225Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M878.287 44.0225H895.169L934.062 95.0956V44.0225H952.012V127.15H936.412L896.237 74.3672V127.15H878.287V44.0225Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.711 127.577H156.639L182.709 82.701L156.639 37.6113H104.711L78.8535 82.701L104.711 127.577Z",
    fill: "#22E52E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4545 0H0V165.4H16.4545V0Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.433 0H126.291L116.889 16.4545H169.03L207.282 82.7L169.03 148.945H116.889L126.291 165.4H178.433L226.087 82.7L178.433 0Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.933 165.186L54.2791 82.7L101.933 0H82.9142L35.2598 82.7L82.9142 165.186H101.933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcLogoFull);
export default __webpack_public_path__ + "static/media/kc-logo-full.55d7d4ef5fcb3598dd5758e35c40a0a3.svg";
export { ForwardRef as ReactComponent };